import { render, staticRenderFns } from "./CompanyOnboardingView.vue?vue&type=template&id=18d229e7&scoped=true"
import script from "./CompanyOnboardingView.vue?vue&type=script&lang=js"
export * from "./CompanyOnboardingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d229e7",
  null
  
)

export default component.exports